import { Component, Input, ElementRef, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { Hero } from '../../interfaces/hero';
import * as $ from 'jquery';

@Component({
  selector: 'app-subpage-hero',
  templateUrl: './subpage-hero.component.html',
  styleUrls: ['./subpage-hero.component.scss']
})
export class SubpageHeroComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() hero: Hero;
  $window;
  $hero;
  $nav;

  constructor(
    private el: ElementRef
  ) { }

  checkIfHeroInView() {
    const elementTop = this.$hero.offset().top;
    const elementBottom = elementTop + this.$hero.outerHeight() - 150; // change color a bit before hero is out of view
    const viewportTop = this.$window.scrollTop();
    const viewportBottom = viewportTop + this.$window.height();
    const isInView = elementBottom > viewportTop && elementTop < viewportBottom;

    if (isInView) {
      this.$nav.addClass('white-nav');
    } else {
      this.$nav.removeClass('white-nav');
    }
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.$window = $(window);
    this.$nav = $('[data-nav]');
    this.$hero = $('[data-subpage-hero]', this.el.nativeElement);

    // Nav should have white fill when over the subpage hero
    this.checkIfHeroInView();

    this.$window.on('scroll.subpagehero', () => {
      this.checkIfHeroInView();
    });
    this.$window.on('resize.subpagehero', this.checkIfHeroInView());
  }

  ngOnDestroy() {
    if (this.$window) {
      this.$window.off('scroll.subpagehero');
      this.$window.off('resize.subpagehero');
    }

    this.$nav.removeClass('white-nav');
  }
}
